// components/StageGate — render bertahap (speed 2026-10-22, dipakai LP + form).
// 1) konten utama sync; 2) sisanya dibuka via gate. mode 'idle' = sesudah
// browser luang (cepat, mis. deskripsi awal); 'view' = saat dekat viewport
// (anti-CLS: konten di bawah fold). Timeout paksa 5 dtk: pixel/SEO tetap kebaca.
import React from 'react';
import { onIdle } from '../../utils/idleCallback';

interface Props {
    children: React.ReactNode;
    mode?: 'idle' | 'view';
    idleMs?: number;
    maxWaitMs?: number;
    minHeight?: number;
}

export const StageGate: React.FC<Props> = ({ children, mode = 'view', idleMs = 1200, maxWaitMs = 5000, minHeight = 120 }) => {
    // Halaman STATIS (SSR): konten WAJIB ikut ter-render di server — kalau tidak,
    // HTML statis hanya berisi placeholder kosong (deskripsi/review/footer hilang).
    // Flag dipasang script inline sebelum bundle hidrasi → klien render pertama
    // identik (anti hydration mismatch). SPA biasa tidak terpengaruh.
    const isStatic = typeof window === 'undefined' || !!(window as any).__LP_STATIC__ || !!(window as any).__FORM_STATIC__;
    const [open, setOpen] = React.useState(isStatic);
    const ref = React.useRef<HTMLDivElement | null>(null);

    React.useEffect(() => {
        if (isStatic) return;
        let done = false;
        const show = () => { if (!done) { done = true; setOpen(true); } };
        const timer = window.setTimeout(show, maxWaitMs);
        let cancelIdle: (() => void) | null = null;
        let observer: IntersectionObserver | null = null;
        if (mode === 'idle') {
            cancelIdle = onIdle(show, idleMs);
        } else if (ref.current && typeof IntersectionObserver !== 'undefined') {
            observer = new IntersectionObserver(entries => {
                if (entries.some(e => e.isIntersecting)) show();
            }, { rootMargin: '400px' });
            observer.observe(ref.current);
        } else {
            show();
        }
        return () => {
            done = true;
            window.clearTimeout(timer);
            cancelIdle?.();
            observer?.disconnect();
        };
    }, [mode, idleMs, maxWaitMs]);

    if (open) return <>{children}</>;
    return <div ref={ref} style={{ minHeight }} aria-hidden="true" />;
};

export default StageGate;
